import { proxy } from 'valtio'

export const trafficLightStore = proxy({
  state: '' as 'red' | 'yellow' | 'green',
})
